import { forwardRef } from 'react';

import type { SVGIconProps } from '../types';

export const PortUsbTypeAIcon = forwardRef<SVGSVGElement, SVGIconProps>(
  ({ color = 'currentColor', size = 16, ...props }, ref) => (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id="mask0_51_321"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="16"
      >
        <rect width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_51_321)">
        <path
          d="M2.75 7.60478C2.75 7.38387 2.92909 7.20478 3.15 7.20478H12.85C13.0709 7.20478 13.25 7.38387 13.25 7.60478V9.03206C13.25 9.25297 13.0709 9.43206 12.85 9.43206H3.15C2.92909 9.43206 2.75 9.25297 2.75 9.03206V7.60478Z"
          fill={color}
        />
        <path
          d="M3.86364 6.96842C3.86364 6.74751 4.04272 6.56842 4.26364 6.56842H5.05455C5.27546 6.56842 5.45455 6.74751 5.45455 6.96842V8.39569C5.45455 8.61661 5.27546 8.79569 5.05455 8.79569H4.26364C4.04272 8.79569 3.86364 8.61661 3.86364 8.39569V6.96842Z"
          fill={color}
        />
        <path
          d="M6.09091 6.96842C6.09091 6.74751 6.27 6.56842 6.49091 6.56842H7.28182C7.50273 6.56842 7.68182 6.74751 7.68182 6.96842V8.39569C7.68182 8.61661 7.50273 8.79569 7.28182 8.79569H6.49091C6.27 8.79569 6.09091 8.61661 6.09091 8.39569V6.96842Z"
          fill={color}
        />
        <path
          d="M8.31818 6.96842C8.31818 6.74751 8.49727 6.56842 8.71818 6.56842H9.50909C9.73 6.56842 9.90909 6.74751 9.90909 6.96842V8.39569C9.90909 8.61661 9.73001 8.79569 9.50909 8.79569H8.71818C8.49727 8.79569 8.31818 8.61661 8.31818 8.39569V6.96842Z"
          fill={color}
        />
        <path
          d="M10.5455 6.96842C10.5455 6.74751 10.7245 6.56842 10.9455 6.56842H11.7364C11.9573 6.56842 12.1364 6.74751 12.1364 6.96842V8.39569C12.1364 8.61661 11.9573 8.79569 11.7364 8.79569H10.9455C10.7245 8.79569 10.5455 8.61661 10.5455 8.39569V6.96842Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15 5.15C15 4.92909 14.8209 4.75 14.6 4.75H1.4C1.17909 4.75 1 4.92909 1 5.15V10.85C1 11.0709 1.17909 11.25 1.4 11.25H14.6C14.8209 11.25 15 11.0709 15 10.85V5.15ZM14 6.15C14 5.92909 13.8209 5.75 13.6 5.75H2.4C2.17909 5.75 2 5.92909 2 6.15V9.85C2 10.0709 2.17909 10.25 2.4 10.25H13.6C13.8209 10.25 14 10.0709 14 9.85V6.15Z"
          fill={color}
        />
      </g>
    </svg>
  ),
);

PortUsbTypeAIcon.displayName = 'PortUsbTypeAIcon';
